import { makeStyles, css } from '@conexasaude/hero-web'

const useStyles = makeStyles({
  backdrop: () => css`
    z-index: 99999;
  `,

  modal: () => css`
    z-index: 999999;
    height: unset;
  `,

  modalContent: () => css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    svg {
      width: 64px;
      height: 64px;
    }

    strong {
      display: flex;
      margin-top: 8px;
      font-size: 24px;
      text-align: center;
    }

    p {
      margin-top: 32px;
    }
  `,

  declineButton: () => css`
    border: none;
  `,
})

export { useStyles }
